import { Component, inject, signal } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-no-access',
  imports: [],
  templateUrl: './no-access.html',
  styleUrls: [
    './no-access.scss',
    '../../../styles/_common.scss',
    '../../../styles/_button.scss'
]
})
export class NoAccess {
    private readonly _authService = inject(AuthService);
    private readonly _router = inject(Router);
    private readonly _toastr = inject(ToastrService);

    protected isTokensRefreshing = signal(false);

    protected logout() {
        this._authService.signOut();
    }

    protected async redirectToHomePage(): Promise<void> {
        if(this.isTokensRefreshing()) {
            return;
        }
        this.isTokensRefreshing.set(true);
        try {
            await this._authService.refreshTokens();
            const user = this._authService.loggedUser.value;
            if (user?.inGroup) {
                this._router.navigate(['/', 'home']);
            } else {
                this._toastr.error('You do not have access to this application.', 'Forbidden');
            }
        } catch (error) {
            console.error('Failed to refresh tokens:', error);
        } finally {
            this.isTokensRefreshing.set(false);
        }
    }
}
